/*GET SCENARIO RISK INDICATORS BY SCENARIO ID*/
export const FETCH_RI_LIST_BY_SCENARIO_ID = 'FETCH_RI_LIST_BY_SCENARIO_ID';
export const FETCH_RI_LIST_BY_SCENARIO_ID_SUCCESS =
  'FETCH_RI_LIST_BY_SCENARIO_ID_SUCCESS';
export const FETCH_RI_LIST_BY_SCENARIO_ID_FAIL =
  'FETCH_RI_LIST_BY_SCENARIO_ID_FAIL';
export const FETCH_RI_BY_SCENARIO_ID = 'FETCH_RI_BY_SCENARIO_ID';
export const FETCH_RI_BY_SCENARIO_ID_SUCCESS =
  'FETCH_RI_BY_SCENARIO_ID_SUCCESS';
export const FETCH_RI_BY_SCENARIO_ID_FAIL = 'FETCH_RI_BY_SCENARIO_ID_FAIL';
export const RISK_INDICATORS_RESET = 'RISK_INDICATORS_RESET';
export const PUT_RI_BY_SCENARIO_ID = 'PUT_RI_BY_SCENARIO_ID';
export const PUT_RI_BY_SCENARIO_ID_SUCCESS = 'PUT_RI_BY_SCENARIO_ID_SUCCESS';
export const PUT_RI_BY_SCENARIO_ID_FAIL = 'PUT_RI_BY_SCENARIO_ID_FAIL';

export function fetchRIListByScenarioId(payload) {
  return {
    type: FETCH_RI_LIST_BY_SCENARIO_ID,
    payload
  };
}

export function fetchRIListByScenarioIdSuccess(payload) {
  return {
    type: FETCH_RI_LIST_BY_SCENARIO_ID_SUCCESS,
    payload
  };
}

export function fetchRIListByScenarioIdFail(payload) {
  return {
    type: FETCH_RI_LIST_BY_SCENARIO_ID_FAIL,
    payload
  };
}

export function fetchRIByScenarioId(payload) {
  return {
    type: FETCH_RI_BY_SCENARIO_ID,
    payload
  };
}

export function fetchRIByScenarioIdSuccess(payload) {
  return {
    type: FETCH_RI_BY_SCENARIO_ID_SUCCESS,
    payload
  };
}

export function fetchRIByScenarioIdFail(payload) {
  return {
    type: FETCH_RI_BY_SCENARIO_ID_FAIL,
    payload
  };
}

export function unMountRiskIndicators(payload) {
  return {
    type: RISK_INDICATORS_RESET,
    payload
  };
}

export function putRIByScenarioId(payload) {
  return {
    type: PUT_RI_BY_SCENARIO_ID,
    payload
  };
}

export function putRIByScenarioIdSuccess(payload) {
  return {
    type: PUT_RI_BY_SCENARIO_ID_SUCCESS,
    payload
  };
}

export function putRIByScenarioIdFail(payload) {
  return {
    type: PUT_RI_BY_SCENARIO_ID_FAIL,
    payload
  };
}
